import axios from 'axios'
import qs from 'qs'
import { Loading } from 'mint-ui';
import {dialog} from "./dialog";
import {cookie} from "./cookie";
import {url} from "./url";
import {requestSign} from "./requestSign.js"
/***
 * http://www.axios-js.com/zh-cn/docs/ axios参数配置详细说明
 */
/**
 * Request 类用于数据请求，目前只定义了
 */
var request= new class {
  requestConfig={
    codes:{
      //正常返回数据的code码
      NORMAL: 200,
      //定义其他code码同等正常数据的code码
      NORMAL_CODES: {
        200: 200
      },
      //缺少token
      NO_TOKEN: 40301
    },
    baseUrl:"",
    useMock:false,
    needSign:false
  };

  constructor(config){
    this.url=url;
    this.dialog=dialog;
    this.cookie=cookie;
    this.baseURL=this.url.baseUrl;
    this.requestSign=new requestSign({
      questTool:this
    });

    // this.log=new Log();
    // if(config){
    //   this.requestConfig=Object.assign(this.requestConfig,config);
    // }

    this.http=axios.create({
      baseURL:this.url.baseUrl
      // withCredentials:true
    })

    //设置默认header
    this.http.defaults.headers.get={
      'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8',
      "source":"1",
      "platform":"4"
    }
    this.http.defaults.headers.post={
      'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8',
      "source":"1",
      "platform":"4"
    }

    // let fn=function(){}
    // 设置请求拦截器
    this.http.interceptors.request.use(function (config) {
      if(config.needStringify){
        config.data=qs.stringify(config.data)
      }
      
      return config;
    }, function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    });

    // 响应拦截器
    this.http.interceptors.response.use((res) => {
      return res;
    }),(err)=>{
      console.log('请求失败',err)
    }

  }
  notoken() {
    // todo
  }
  base(options){
    var that=this;
    //默认请求参数和处理方法
    let _options={
      method:"get",
      needToken:false,
      fail:null
    }
    _options=Object.assign(_options,options);

    // 判断是否有token
    const token=this.cookie.getCookie("token");
    if(_options.needToken && !token){
      //需要token 但没有token时候的处理
      this.notoken();
    }

    // 请求之前ui处理(待添加);

    // 设置baseURL
    if(!_options.baseURL){
      _options.baseURL=this.baseURL;
    }

    //code码处理
    let handleResponse=function (res) {
      //console.log(res.data.code,res.data.result);
      let code;
      if(res.data.code){
        code = res.data.code;//分享接口  获取 appid等
      }else{
        code=res.data.responseHeader.status;
      }

      if (typeof (_options.customCodeHandlers && _options.customCodeHandlers[code]) == 'function') {
        //使用自定义处理方式
        _options.customCodeHandlers[code](res);
      } else if (that.requestConfig.codes.NORMAL_CODES[code] == that.requestConfig.codes.NORMAL) {
        if (_options.success) {
          _options.success(res);
        }
      } else {
        //code异常处理
        if(_options.codeError){
          _options.codeError(res)
        }else{
          that.codeHandler(res);
        }
      }
    }

    if(_options.needStringify){
      _options.data=qs.stringify(_options.data)
    }
    if(_options.method=="get"){
      this.http.get(_options.url,_options).then(handleResponse).catch((e)=>{
        //console.log(_options.baseUrl+_options.url,78,_options)
        //请求错误处理
        if(_options.error)_options.error(e);
      })
    }else{
      //请求错误处理
      this.http.post(_options.url,_options.data,_options).then(handleResponse).catch((e)=>{
        if(_options.error)_options.error(e);
      })
    }
  }
  /**
   * GET 请求数据
   * @param url 请求参数
   * @param data 请求数据，如果没有或者已经拼接到url里面了可置空
   * @param success 请求成功并且code码正常的回调函数
   * @param customCodeHandlers 自定义code码处理
   * 特别注意：当optional有自定义参数请求时候，请求的url和data数据最后都会以第一个url参数和第二个data参数为准
   */
  get(options) {
    let _options={
      method:"get",
      needSign:this.requestConfig.needSign
    }

    _options=Object.assign(_options,options);
    if(_options.needSign){
      this.requestSign.signGet(_options.url,(url)=>{
        _options.url=url;
        this.base(_options);
      })
    }else{
      this.base(_options);
    }


  }
  /**
   * POST 请求数据
   * options自定义属性如下：
   * @param url 请求参数
   * @param data 请求数据，如果没有或者已经拼接到url里面了可置空
   * @param success 请求成功并且code码正常的回调函数
   * @param customCodeHandlers 自定义code码处理
   * 特别注意：当optional有自定义参数请求时候，请求的url和data数据最后都会以第一个url参数和第二个data参数为准
   */
  post(options) {
    let _options={
      method:"post",
      needSign:this.requestConfig.needSign
    }
    _options=Object.assign(_options,options);
    if(_options.needSign){
      this.requestSign.signPost(_options.data,(data)=>{
        _options.data=data;
        this.base(_options);
      })
    }else{
      this.base(_options);
    }


  }
  codeHandler(res) {
    var code = parseInt(res.data.status);
    switch (code) {
      case this.requestConfig.codes.NO_TOKEN:
      {
        //提示登录
        window.localStorage.removeItem('token')
        this.dialog.hintLogin()
        //移除token
      }break;
      default:
      {
        let msg;
        try {
          msg=res.data.responseHeader.message;
        }catch (e) {
          msg=null
        }
        if(!msg){
          // msg=JSON.stringify(res)
          msg="当前请求人数太多，请重试"
        }
        // 提示错误
        this.dialog.hint(msg)

      }break;
    }
  }

}
export {request}




// WEBPACK FOOTER //
// ./static/js/lib/request.js